import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import siteContent from '../content';

const { nav } = siteContent.global;

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (isMenuOpen && !target.closest('.nav') && !target.closest('.mobile-menu-btn')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuOpen]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="header">
      <div className="container">
        <div className="header-inner">
          <Link to="/" className="logo">
            <img src="/logo.svg" alt="Kline Real Estate Works" />
          </Link>

          <nav className={`nav ${isMenuOpen ? 'active' : ''}`} data-cms-page="global" data-cms-section="nav">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              <span data-cms-field="home">{nav.home}</span>
            </Link>
            <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
              <span data-cms-field="about">{nav.about}</span>
            </Link>
            <Link to="/buyers" className={`nav-link ${isActive('/buyers') ? 'active' : ''}`}>
              <span data-cms-field="buyers">{nav.buyers}</span>
            </Link>
            <Link to="/sellers" className={`nav-link ${isActive('/sellers') ? 'active' : ''}`}>
              <span data-cms-field="sellers">{nav.sellers}</span>
            </Link>
            <Link to="/listings" className={`nav-link ${isActive('/listings') ? 'active' : ''}`}>
              <span data-cms-field="listings">{nav.listings}</span>
            </Link>
            <Link to="/search" className={`nav-link ${isActive('/search') ? 'active' : ''}`}>
              <span data-cms-field="search">{nav.search}</span>
            </Link>
            <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
              <span data-cms-field="contact">{nav.contact}</span>
            </Link>
          </nav>

          <button
            className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
